/**获取所有作者名称 */
export const getAuthorName = (data: SwaggerDTO.AuthorInfoDTO[] = []) => {
  return data
    ?.map(c => {
      const country = c.nationalityBrief ? `[${c.nationalityBrief}]` : ''
      const name = c?.authorName
      return `${country}${name}`
    })
    ?.join(', ')
}
